var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfferLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2_3652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 39.8954C0 17.8618 17.9664 0 40 0V0C62.0336 0 80 17.8618 80 39.8954V39.8954C80 61.929 62.0336 79.7908 40 79.7908V79.7908C17.9664 79.7908 0 61.929 0 39.8954V39.8954Z",
    fill: "url(#paint0_radial_2_3652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 79.2908C18.2408 79.2908 0.5 61.6512 0.5 39.8954C0.5 18.1396 18.2408 0.5 40 0.5C61.7592 0.5 79.5 18.1396 79.5 39.8954C79.5 61.6512 61.7592 79.2908 40 79.2908Z",
    stroke: "url(#paint1_radial_2_3652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 79.2908C18.2408 79.2908 0.5 61.6512 0.5 39.8954C0.5 18.1396 18.2408 0.5 40 0.5C61.7592 0.5 79.5 18.1396 79.5 39.8954C79.5 61.6512 61.7592 79.2908 40 79.2908Z",
    stroke: "url(#paint2_radial_2_3652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 79.2908C18.2408 79.2908 0.5 61.6512 0.5 39.8954C0.5 18.1396 18.2408 0.5 40 0.5C61.7592 0.5 79.5 18.1396 79.5 39.8954C79.5 61.6512 61.7592 79.2908 40 79.2908Z",
    stroke: "url(#paint3_radial_2_3652)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2_3652",
    x: -5,
    y: -5,
    width: 90,
    height: 89.7908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_3652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2_3652",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_3652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.69204) rotate(47.9449) scale(119.431 86.7751)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_3652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-42.5965 8.1628) rotate(35.0407) scale(92.1512 54.3882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2_3652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.421 53.4008) rotate(161.385) scale(66.8428 45.1784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8470FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#865CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2_3652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.871 -18.2359) rotate(47.2149) scale(44.643 32.0879)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferLogoColor);
export default __webpack_public_path__ + "static/media/offerLogoColor.f1bf423b697c41eeeea859b8c95f8883.svg";
export { ForwardRef as ReactComponent };